<template>
  <v-card>
    <h1 class="text-xs-center py-5">
      <!-- V:\Data\Admin\_HCL_graphics\_Hatfield_Digital\01_Hatfield_Logo\Hatfield Initiatives\Logo files for Web -->
      <img src="/static/images/logo.svg" width="400px" style="margin-bottom: -12px" />
    </h1>
    <v-card color='grey lighten-4'>
      <v-alert v-if='message' class="text-xs-center" v-model='error'>{{message}}</v-alert>
      <v-progress-linear indeterminate v-if='authenticating'></v-progress-linear>
      <v-form @submit.prevent='attemptLogin' box class="mx-auto" style="max-width: 600px;">
          <v-flex>
            <v-text-field v-model='username' label='Username' box autofocus ref='username' :disabled="needTwoFactor"></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field v-model='password' label='Password' box type='password' :disabled="needTwoFactor"></v-text-field>
          </v-flex>
          <template>
            <v-flex v-if="needTwoFactor">
              <v-text-field class="py-2" v-model='code' label='Security Code' box :error-messages="[twoFactorMessage]"></v-text-field>                       
            </v-flex>

         </template>
         <v-flex>
          <v-btn :loading="sendingTwoFactor" color="warning" @click.native="requestAuthenticationCode" v-if="needTwoFactor">
            Resend Security Code
          </v-btn>
          <v-btn type='submit' :disabled="authenticating" color="primary">{{ $t('Button.Login') }}</v-btn>
         </v-flex>
      </v-form>
      
      <v-divider></v-divider>

      <div class="text-xs-right">
        
        <v-btn @click="office365Login" color="secondary" >
          
          Hatfield Staff Login
        </v-btn>
      </div>

    </v-card>

    
  </v-card>
</template>

<script>
  import anime from 'animejs'
  import { createNamespacedHelpers } from 'vuex'

  import { msLogin } from '../helpers/Office365/azureAuthService'

  const { mapActions, mapGetters } = createNamespacedHelpers('authenticate')

  export default {
    props: {
      redirect: String,
    },
    data() {
      return {
        username: '',
        password: '',
        code: '',
        authenticating: false,
        message: '',
        error: false,
        codetype: '',
        needTwoFactor: false,
        twoFactorMessage: '',
        sendingTwoFactor: false,
      }
    },
    computed: {
      ...mapGetters(['isAuthed']),
      filledCode() {
        return this.code != ''
      },
    },
    watch: {
      $route() {
        anime.timeline()
          .add({
            targets: '.wrd',
            rotate: '10deg',
            scale: 1.2,
            easing: 'easeOutExpo',
            duration: 300,
          })
          .add({
            targets: '.wrd',
            rotate: '0deg',
            scale: 1,
            easing: 'easeInQuad',
            duration: 100,
          })
      },
    },
    methods: {
      ...mapActions(['logIn', 'requestCode']),
      async attemptLogin() {
        this.authenticating = true

        let res = await this.logIn({
          username: this.username,
          password: this.password,
          code: this.code,
          codetype: this.codetype,
        })

        if (res.success) {
          this.error = false
          this.needTwoFactor = false
          this.message = ''

          let redirectPath = this.redirect || { name: 'home' }          
          this.$router.push(redirectPath)
        } else {
          //console.log(res)
          if(res.error == 'need_twofactors') {
            this.codetype = 'Email'
            await this.requestAuthenticationCode()
            this.needTwoFactor = true
          } else {
            this.message = res.message
            this.error = true
            //this.needTwoFactor = false
            this.twoFactorMessage = ''
            this.sendingTwoFactor = false
          }
          
        }

        this.authenticating = false
      },
      async requestAuthenticationCode() {
        this.sendingTwoFactor = true
        let result = await this.requestCode({username: this.username, codetype: this.codetype})
        this.twoFactorMessage = result.Message
        this.sendingTwoFactor = false
      },
      async office365Login() {
        var loggedin = await msLogin()
        if(loggedin) {
          this.$router.push({name: 'Office365AuthResponse'})
        }        
      },
    },
    mounted() {
      this.$nextTick(this.$refs.username.focus)
      if (this.$route.query && this.$route.query.message) {
        this.message = this.$route.query.message
      }
    },
  }
</script>

<style scoped>
  .wrd {
    width: 100%;
    max-width: 450px
  }

  form {
    padding-top: 20px;
    margin: auto;
    width: 50%;
  }
</style>